import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const navItems = [
  { label: 'Dashboard', icon: 'ri-dashboard-line', path: '/admin/dashboard' },
  { label: 'Projects', icon: 'ri-folder-line', path: '/admin/projects' },
  { label: 'Volunteers', icon: 'ri-team-line', path: '/admin/volunteers' },
  { label: 'Stories', icon: 'ri-book-open-line', path: '/admin/stories' },
  { label: 'Messages', icon: 'ri-mail-line', path: '/admin/messages' },
  { label: 'Photos', icon: 'ri-image-line', path: '/admin/photos' },
  { label: 'CMS Content', icon: 'ri-translate-2', path: '/admin/content' },
  { label: 'Pashto CMS', icon: 'ri-text-direction-r', path: '/admin/content/pashto' },
  { label: 'Dari CMS', icon: 'ri-text-direction-r', path: '/admin/content/dari' },
  { label: 'English CMS', icon: 'ri-global-line', path: '/admin/content/english' },
  { label: 'Users', icon: 'ri-user-settings-line', path: '/admin/users', adminOnly: true },
];

export default function AdminSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { profile, signOut, isAdmin } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate('/admin');
  };

  const visibleItems = navItems.filter(item => !item.adminOnly || isAdmin);

  const displayRole = () => {
    if (isAdmin) return 'admin';
    return profile?.role ?? 'editor';
  };

  return (
    <aside className="w-64 min-h-screen bg-[#1B2838] flex flex-col">
      {/* Logo */}
      <div className="px-6 py-6 border-b border-white/10">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#3B9EF5] text-[#1B2838] font-bold text-sm">
            CAF
          </div>
          <div>
            <div className="text-white font-bold text-sm leading-tight">CAF Admin</div>
            <div className="text-[#3B9EF5] text-xs">CMS Portal</div>
          </div>
        </Link>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-5 space-y-1">
        {visibleItems.map((item) => {
          const active = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium cursor-pointer transition-all whitespace-nowrap ${
                active
                  ? 'bg-[#3B9EF5] text-[#1B2838]'
                  : 'text-white/70 hover:text-white hover:bg-white/10'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={item.icon}></i>
              </div>
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* User */}
      <div className="px-4 py-5 border-t border-white/10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white font-bold text-sm">
            {profile?.name?.charAt(0).toUpperCase() ?? 'U'}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-white text-sm font-medium truncate">{profile?.name ?? 'User'}</div>
            <div className="text-white/50 text-xs capitalize">{displayRole()}</div>
          </div>
        </div>
        <button
          onClick={handleSignOut}
          className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-white/60 hover:text-white hover:bg-white/10 text-sm cursor-pointer transition-colors whitespace-nowrap"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-logout-box-line"></i>
          </div>
          Sign Out
        </button>
      </div>
    </aside>
  );
}
